import FDrawerMDP from "@/components/FDrawerMDP";
import NotesListMDP from "./NotesListMDP";

export default class NotesDrawerMDP extends FDrawerMDP {
    constructor(props: { isVisible: boolean, onClose: () => void, customerDetails: any; notesAdded: () => void }) {
        super({ childMDP: new NotesListMDP({ 
            customerDetails: props.customerDetails,
            notesAdded: props.notesAdded,
        }), ...props, myRefName: "NotesDrawerRef",title:"Notes",width:"50%" })

    }
}